import { Directive } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl } from '@angular/forms';

const POSTCODE_PATTERN = /^((\d{5})|(\d{6}))$/;

@Directive({
    selector: '[jhiPostcode][ngModel]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: PostCodeValidatorDirective, multi: true }
    ]
})
export class PostCodeValidatorDirective implements Validator {

    validate(c: AbstractControl): { [key: string]: any; } {

        if (!c.value) {
            return null;
        }

        if (!c.value.match(POSTCODE_PATTERN)) {
            return { 'invalid-postcode': true };
        }
        return null;
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/components/forms/validators/postcode-validator.ts